import React from 'react'
import { CheckboxTable, CheckboxTableColum, HCR9BenefitInformationResponse, ModalComponent, SortFieldInfo } from '@pulseops/common'
import { StyleSheet, useWindowDimensions, View } from 'react-native'

type HCR9BenefitInformationModalProps = {
  isOpen: boolean
  handleClose: () => void
  modalTitle?: string
  HCR9BenefitInformation: HCR9BenefitInformationResponse[]
  displayedColumns: CheckboxTableColum[]
}
export const HCR9BenefitInformationModal = (props: HCR9BenefitInformationModalProps) => {
  const { isOpen, handleClose, HCR9BenefitInformation, displayedColumns, modalTitle } = props
  const { width } = useWindowDimensions()
  const [sortItem, setSortItem] = React.useState<SortFieldInfo>({
    field: '',
    order: 'asc'
  })
  return (
    <ModalComponent
      title={modalTitle || ''}
      modalWidth={Math.min(width * 0.9, 760)}
      centerTitle={true}
      visible={isOpen}
      onClose={handleClose}
      actions={[]}
      buttonGroupStyle={benefitStyles.buttonContainer}
    >
      <View
        style={{
          marginHorizontal: 20,
          marginTop: 16
        }}
      >
        <View style={{ width: '100%' }}>
          <CheckboxTable
            displayedColumns={displayedColumns}
            dataSource={HCR9BenefitInformation}
            stickyHeader
            isPagination={false}
            sortItem={sortItem}
            setSortItem={setSortItem}
            containerStyle={benefitStyles.tableContainer}
          />
        </View>
      </View>
    </ModalComponent>
  )
}
const benefitStyles = StyleSheet.create({
  tableContainer: {
    marginVertical: 0
  },
  buttonContainer: {
    marginTop: 10,
    marginBottom: 10
  }
})